import {
  GET_LIST_TONGQUATCUAHANG,
  GET_LIST_TONGQUATCUAHANG_SUCCESS,
  GET_LIST_TONGQUATCUAHANG_FAILURE,
} from "./actionTypes";

export const getListTongQuatCuaHang = (dataSearch) => ({
  type: GET_LIST_TONGQUATCUAHANG,
  dataSearch,
});

export const getListTongQuatCuaHangSuccess = (data) => ({
  type: GET_LIST_TONGQUATCUAHANG_SUCCESS,
  payload: data,
});

export const getListTongQuatCuaHangFailure = () => ({
  type: GET_LIST_TONGQUATCUAHANG_FAILURE,
});
